export default "__VITE_ASSET__BmTlUBzX__"